<template>
  <div id="container">
    <header>
      <nav class="navbar navbar-default navbar-static-top" role="navigation">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target=".navbar-collapse"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand-admin" to="/admin"
            >Dados Abertos - Admin</router-link
          >
        </div>
        <!-- /.navbar-header -->

        <ul id="menu-principal" class="nav navbar-top-links navbar-right">
          <li class="dropdown right">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
              <font-awesome-icon :icon="'user'" /><font-awesome-icon
                :icon="'caret-down'"
              />
            </a>
            <ul class="dropdown-menu dropdown-user">
              <li>
                <a href="#"
                  >Perfil<font-awesome-icon :icon="'user'" class="icones-margem"
                /></a>
              </li>
              <li class="divider"></li>
              <li>
                <a href="#" @click="logout">
                  Logout<font-awesome-icon
                    :icon="'sign-out-alt'"
                    class="icones-margem"
                  />
                </a>
              </li>
            </ul>
            <!-- /.dropdown-user -->
          </li>
          <!-- /.dropdown -->
        </ul>
        <!-- /.navbar-top-links -->

        <div class="navbar-default sidebar" role="navigation">
          <div class="sidebar-nav collapse navbar-collapse">
            <ul class="nav" id="side-menu">
              <li v-for="menu in menus" :key="menu.nome">
                <a
                  v-if="menu.hasOwnProperty('submenus')"
                  href="#"
                  :class="{ active: menu.active }"
                >
                  <font-awesome-icon :icon="menu.iconName" />
                  {{ menu.nome }}
                  <font-awesome-icon :icon="'caret-down'"></font-awesome-icon>
                </a>
                <a v-else @click.prevent="changePartialView(menu)" href="#">
                  <font-awesome-icon :icon="menu.iconName" />
                  {{ menu.nome }}
                </a>
                <ul
                  v-if="menu.hasOwnProperty('submenus')"
                  class="nav nav-second-level"
                >
                  <li v-for="submenu in menu.submenus" :key="submenu.nome">
                    <a
                      @click.prevent="changePartialView(submenu)"
                      href="#"
                      :class="{ active: submenu.active }"
                    >
                      <font-awesome-icon :icon="submenu.iconName" />
                      {{ submenu.nome }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!-- /.sidebar-collapse -->
        </div>
        <!-- /.navbar-static-side -->
      </nav>
    </header>
    <div id="page-content" class="page-print">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    
    <auto-progress/>
    <modal ref="modal"/>
    <modal-alert ref="modalAlert"/>
    <login-modal ref="loginModal"/>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import ModalAlert from '@/components/common/ModalAlert'
import LoginModal from '@/components/auth/LoginModal'
import autoProgress from 'vue-auto-progress'
export default {
  name: 'index',
  components: {
    Modal,
    ModalAlert,
    LoginModal,
    autoProgress
  },
  provide() {
    return {
      showAlert: this.showAlert,
      closeAlert: this.closeAlert,
      showConfirm: this.showConfirm,
      closeConfirm: this.closeConfirm,
      showLoginModal: this.showLoginModal,
      closeLoginModal: this.closeLoginModal
    }
  },
  data() {
    return {
      menus: [],
      menusActive: []
    }
  },
  created() {
    this.loadMenus()
  },
  methods: {
    loadMenus() {
      const { perfis } = this.$store.state.user

      if (!perfis) {
        return
      }

      const isAdmin = perfis.includes('admin')

      this.menus.push({
        nome: 'Painel',
        url: '/admin/painel',
        iconName: 'tachometer-alt'
      })

      if (isAdmin) {
        this.menus.push({
          nome: 'Usuários',
          url: '/admin/users/list',
          iconName: 'address-card'
        })
        this.menus.push({
          nome: 'Dados',
          iconName: 'cube',
          submenus: [
            {
              nome: 'Lista de dados',
              url: '/admin/dado/list',
              iconName: 'cube'
            },
            {
              nome: 'Tags',
              url: '/admin/tags/list',
              iconName: 'tags'
            },
            {
              nome: 'Eixos',
              url: '/admin/eixos/list',
              iconName: 'th-large'
            },
            {
              nome: 'Metas',
              url: '/admin/metas/list',
              iconName: 'check-circle'
            },
            {
              nome: 'Associar usuários e dados',
              url: '/admin/users/associate',
              iconName: 'sitemap'
            },
            {
              nome: 'Relatórios',
              url: '/admin/relatorio',
              iconName: 'file-alt'
            }
          ]
        })
      }

      if (perfis.includes('emendas-default')) {
        this.menus.push({
          nome: 'Emendas Parlamentares',
          iconName: 'landmark',
          submenus: [
            {
              nome: 'Emendas',
              url: '/admin/emenda/list',
              iconName: 'file-alt'
            },
            {
              nome: 'Vereadores',
              url: '/admin/vereador/list',
              iconName: 'user-tie'
            },
            {
              nome: 'Processos de Pagamento',
              url: '/admin/processospagamento/list',
              iconName: 'money-check-alt'
            }
          ]
        })
      }

      if (perfis.includes('default') || perfis.includes('temporario')) {
        this.menus.push({
          nome: 'Dados do Usuário',
          iconName: 'cube',
          submenus: [
            {
              nome: 'Lista de dados',
              url: '/admin/user/dado/list',
              iconName: 'cube'
            }
          ]
        })
      }

      let menusEscalaSMS = []
      if (perfis.includes('sms-admin') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Relatório de status',
          url: '/admin/escalas/relatorio',
          iconName: 'calendar-check'
        })
        menusEscalaSMS.push({
          nome: 'Vincular unidades ao usuário',
          url: '/admin/escalas/vincular-unidades-usuario',
          iconName: 'sitemap'
        })
        menusEscalaSMS.push({
          nome: 'Relações entre perfis e unidades',
          url: '/admin/escalas/relatorio-perfil-unidade',
          iconName: 'user-tag'
        })
      }

      if (perfis.includes('sms-gest') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Publicar escalas',
          url: '/admin/escalas/publicar',
          iconName: 'calendar-check'
        })
      }

      if (perfis.includes('sms-admin') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Remover publicação',
          url: '/admin/escalas/remover-publicacao',
          iconName: 'calendar-times'
        })
      }

      if (perfis.includes('sms-gest') && !isAdmin) {
        menusEscalaSMS.push({
          nome: 'Relações entre perfis e unidades',
          url: '/admin/escalas/gestao-perfil-unidade',
          iconName: 'user-tag'
        })
      }

      if (perfis.includes('sms-user') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Pendências',
          url: '/admin/escalas/pendentes',
          iconName: 'calendar-check'
        })
        menusEscalaSMS.push({
          nome: 'Escalas',
          url: '/admin/escalas/list',
          iconName: 'calendar-alt'
        })
        menusEscalaSMS.push({
          nome: 'Impressão',
          url: '/admin/escalas/impressao',
          iconName: 'print'
        })
      }

      if (
        perfis.includes('sms-admin') ||
        perfis.includes('sms-gest') ||
        perfis.includes('sms-user') ||
        isAdmin
      ) {
        this.loadEscalaFuncionarios()

        this.menus.push({
          nome: 'Escalas SMS',
          iconName: 'calendar-check',
          submenus: [...menusEscalaSMS]
        })
      } else {
        this.$store.commit('INITIALIZED', true)
      }

      const planoDeGovernoMenuBase = {
        nome: 'Plano de Governo',
        url: '/admin/planogoverno',
        iconName: 'file-alt',
        submenus: []
      };

      if (perfis.includes('pdg-master')) {
        planoDeGovernoMenuBase.submenus.push(
          {
            nome: 'Importar Compromissos',
            url: '/admin/planogoverno/compromisso/importar',
            iconName: 'upload'
          },
          {
            nome: 'Responsáveis Compromissos',
            url: '/admin/planogoverno/compromisso/editar',
            iconName: 'edit'
          }
        );
      }

      if (perfis.includes('pdg-gestor')) {
        planoDeGovernoMenuBase.submenus.push(
          {
            nome: 'Meus Compromissos',
            url: '/admin/planogoverno/compromisso',
            iconName: 'file-alt'
          }
        );
      }

      if (perfis.includes('pdg-user')) {
        planoDeGovernoMenuBase.submenus.push(
          {
            nome: 'Minhas Ações',
            url: '/admin/planogoverno/acao',
            iconName: 'file-alt'
          }
        );
      }

      if (planoDeGovernoMenuBase.submenus.length > 0) {
        this.menus.push(planoDeGovernoMenuBase);
      }

      if (perfis.includes('mp-user') || isAdmin) {
        let menusMP = []
        menusMP.push({
          nome: 'Materiais Padronizados',
          url: '/admin/material/list',
          iconName: 'cube'
        })
        menusMP.push({
          nome: 'Medidas',
          url: '/admin/material/medida/list',
          iconName: 'balance-scale'
        })
        menusMP.push({
          nome: 'Grupos',
          url: '/admin/material/grupo/list',
          iconName: 'th-large'
        })
        menusMP.push({
          nome: 'Subgrupos',
          url: '/admin/material/subgrupo/list',
          iconName: 'sitemap'
        })

        this.menus.push({
          nome: 'Materiais Padronizados',
          iconName: 'cube',
          submenus: [...menusMP]
        })
      }

      if (perfis.includes('assistencia') || isAdmin) {
        const menusAssist = [
          {
            nome: 'Benefícios',
            url: '/admin/assistencia/beneficios',
            iconName: 'hand-holding-heart'
          },
          {
            nome: 'Pagamentos de benefícios',
            url: '/admin/assistencia/pagamentos',
            iconName: 'money-bill'
          }
        ]

        this.menus.push({
          nome: 'Assistência Social',
          iconName: 'hand-holding-heart',
          submenus: [...menusAssist]
        })
      }

      this.menus = this.menus.map(item => {
        item.active = false
        if (item.hasOwnProperty('submenus')) {
          item.submenus = item.submenus.map(subItem => {
            subItem.active = false
            subItem.parent = item
            return subItem
          })
        }
        return item
      })

      if (
        perfis.includes('concursos-admin') ||
        perfis.includes('concursos-default') ||
        isAdmin
      ) {
        const menuEdital = {
          nome: 'Editais',
          url: '/admin/concursos/edital',
          iconName: 'list'
        }

        const menuAcompanhamento = {
          nome: 'Acompanhamento',
          url: '/admin/concursos/acompanhamento',
          iconName: 'chart-line'
        }

        let menusConcurso = []

        if (perfis.includes('concursos-default')) {
          menusConcurso = [menuAcompanhamento]
        }
        if (perfis.includes('concursos-admin') || isAdmin) {
          menusConcurso = [menuEdital, menuAcompanhamento]
        }

        this.menus.push({
          nome: 'Concursos Públicos',
          iconName: 'clipboard-list',
          submenus: [...menusConcurso]
        })
      }

      if (perfis.includes('ods') || isAdmin) {
        const menusODS = [
          {
            nome: 'Movimentos ODS',
            url: '/admin/ods/movimentos',
            iconName: 'running'
          }
        ]

        this.menus.push({
          nome: 'ODS',
          iconName: 'flag-checkered',
          submenus: [...menusODS]
        })
      }

      this.menus = this.menus.map(item => {
        item.active = false
        if (item.hasOwnProperty('submenus')) {
          item.submenus = item.submenus.map(subItem => {
            subItem.active = false
            subItem.parent = item
            return subItem
          })
        }
        return item
      })
    },
    loadEscalaFuncionarios() {
      this.$store.dispatch('loadFuncionarios')
    },
    changePartialView(menu) {
      this.toogleActive(menu)
      this.$router.push(menu.url)

      // resetando os dados de state da vuetable para o state de uma table não interferir na outra
      //this.$store.commit('RESET_VUETABLE_STATE')
    },
    toogleActive(menu) {
      this.resetMenuActives()

      const value = !menu.active
      menu.active = value

      this.menusActive.push(menu)

      if (menu.hasOwnProperty('parent')) {
        menu.parent.active = value
        this.menusActive.push(menu.parent)
      }
    },
    resetMenuActives() {
      this.menusActive.forEach(menu => {
        menu.active = false
      })
      this.menusActive = []
    },
    logout() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    showAlert(options) {
      this.$refs.modalAlert.show(options)
    },
    closeAlert() {
      this.$refs.modalAlert.close()
    },
    showConfirm(message, config) {
      this.$refs.modal.confirm(message, config)
    },
    closeConfirm() {
      this.$refs.modal.close()
    },
    showLoginModal() {
      this.$refs.loginModal.show()
    },
    closeLoginModal() {
      this.$refs.loginModal.hide()
    }
  }
}
</script>

<style scoped>
div#page-content {
  min-height: 93vh;
}

#container header nav a.navbar-brand-admin {
  float: left;
  height: 50px;
  padding: 15px 15px;
  font-size: 20px;
  line-height: 20px;
  font-weight: bold;
}

.nav > li > a {
  color: #c1d1c1;
}

.nav > li > a:hover {
  color: #a1be4d;
}

.nav > li > a.active {
  color: #a1be4d;
  outline: 1px dashed rgba(255, 255, 255, 0);
}

ul.nav > li > a > span.fa.arrow:before {
  content: '\f104';
}

ul.nav > li > a:hover > span.fa.arrow:before,
ul.nav > li > a.active > span.fa.arrow:before {
  content: '\f107';
}

ul.nav-second-level {
  visibility: hidden;
  opacity: 0;
  height: auto;
  max-height: 0px;
  transition: opacity 0.8s, max-height 0.5s ease-in-out;
}

ul.nav-second-level a {
  padding-left: 37px;
}

ul.nav > li > a:hover + ul.nav-second-level,
ul.nav > li > a.active + ul.nav-second-level {
  visibility: visible;
  opacity: 1;
  max-height: 330px;
}

ul.nav-second-level:hover {
  visibility: visible;
  opacity: 1;
  max-height: 330px;
}

#container {
  background-color: #002220;
}

.fa-caret-down {
  margin-left: 5px;
}

.direita-margin {
  margin-right: 5px;
}

.icones-margem {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/index.vue